export default {
    title: "Programa de Fidelidad",
    success_message: "Actualizado con éxito",
    points_reais_relation: "Relación puntos - moneda",
    points_reais_relation_subtitle:
        "¿Cuánto dinero necesita gastar el cliente para ganar 1 punto?",
    currency: "Moneda",
    max_points_per_order: "Máximo de puntos por pedido",
    max_points_per_order_subtitle:
        "¿Cuál es el máximo de puntos que un cliente puede ganar en un solo pedido? Deje en blanco para no tener límite.",
    points: "Puntos",
    warning_order_value: "Valor límite para alerta",
    warning_order_value_subtitle:
        "Si se genera un pedido con un valor superior al informado aquí, el operador tendrá que confirmar el pedido antes de guardarlo.",
    how_to_use_title: "Instrucciones de uso",
    how_to_use_subtitle:
        "Texto que aparece después de que el cliente genera el cupón explicando cómo canjear el beneficio.",
    call_to_action_title: "Llamada a la acción: Registro/Evaluación",
    call_to_action_subtitle:
        "Texto enviado por SMS al cliente al solicitar que complete su registro en Kevi.",
    smart_tags_subtitle:
        "Puedes usar las siguientes etiquetas de sustitución inteligente en tu contenido:",
    accents_removed: "*Todos los acentos serán eliminados.",
    rules_title: "Reglas",
    rules_subtitle:
        "Texto que aparece en el panel del cliente cuando hace clic en reglas.",
    save_button: "Guardar",
    page_title: "Kevi | Programa de Fidelidad",
    lifetime_too_short:
        "El tiempo de validez del cupón debe ser de al menos un día.",
    token_copied: "¡Token copiado con éxito!",
    journey: {
        title: "Jornada",
        stages: "Etapas",
        add_stage_placeholder: "Agregar etapa",
        board_prefix: "Prefijo del tablero",
        board_renamed: "Tablero renombrado",
        insert_first_stage: "Insertar primera etapa",
        insert_first_substage: "Insertar primera subetapa",
        order_saved: "Orden guardado",
        stage_renamed: "Etapa renombrada",
    },
    plugins: {
        title: "Plugins",
        add_sender: "Agregar remitente",
        cost_per_message: "Costo por mensaje",
        credits: "Créditos",
        edit_sender: "Editar remitente",
        monthly_value: "Valor mensual",
        none_registered: "Ninguno registrado",
        register_sender: "Registrar remitente",
        save_changes: "Guardar cambios",
        send_test_to: "Enviar prueba a",
        sender: "Remitente",
        sender_saved_test_sent: "Remitente guardado y prueba enviada",
        soon: "Próximamente",
    },
    products: {
        title: "Productos",
        add_recommendation_optional: "Agregar recomendación (opcional)",
        add_to_group: "Agregar al grupo",
        added_products: "Productos agregados",
        ai: "IA",
        ai_placeholder: "Marcador de posición de IA",
        ai_recommendation_disclaimer: "Descargo de responsabilidad de recomendación por IA",
        also_bought: "También compró",
        batch_edit: "Edición por lotes",
        bought_in_same_order: "Comprado en el mismo pedido",
        bought_together: "Comprado junto",
        brand: "Marca",
        clients_who_bought_also_bought: "Clientes que compraron también compraron",
        cost: "Costo",
        current_price: "Precio actual",
        external_id: "ID externo",
        group: "Grupo",
        group_name: "Nombre del grupo",
        group_updated: "Grupo actualizado",
        groups: "Grupos",
        last_10_orders_including_product: "Últimos 10 pedidos incluyendo producto",
        last_purchase: "Última compra",
        link_removed: "Enlace eliminado",
        manage_groups: "Administrar grupos",
        manual: "Manual",
        manual_recommendation_disclaimer: "Descargo de responsabilidad de recomendación manual",
        new_group: "Nuevo grupo",
        no_images: "Sin imágenes",
        no_manual_links: "Sin enlaces manuales",
        orders_12m: "Pedidos 12m",
        price_unit: "Unidad de precio",
        product_linked: "Producto vinculado",
        product_not_found: "Producto no encontrado",
        products_updated: "Productos actualizados",
        purchase_history: "Historial de compras",
        recommendation_saved: "Recomendación guardada",
        remove_from_group: "Eliminar del grupo",
        repurchase_days: "Días para recompra",
        revenue_12m: "Ingresos 12m",
        search_product_to_link: "Buscar producto para vincular",
        something_went_wrong: "Algo salió mal",
        stock: "Stock",
        use_ai: "Usar IA",
    },
    translations: {
        title: "Traducciones",
        description: "Descripción",
        error_saving: "Error al guardar",
        items_for: "Elementos para",
        key: "Clave",
        locale: "Configuración regional",
        no_categories_found: "No se encontraron categorías",
        no_translations_found: "No se encontraron traducciones",
        original_en: "Original (EN)",
        saved: "Guardado",
        saving: "Guardando",
        translated: "Traducido",
        unable_to_load: "No se puede cargar",
        unable_to_load_items: "No se pueden cargar elementos",
    },
    connections: {
        title: "Conexiones",
        add_page_title: "Agregar Conexiones",
        add_new: "Agregar nueva conexión",
        my_connections: "Mis conexiones",
        first_connection_title: "Haz tu primera conexión",
        first_connection_description: "Conéctate con las principales plataformas",
        channel_placeholder: "Seleccione el canal",
        webhook_read_help: "Los webhooks se usan para recibir el estado de lectura y entrega de los mensajes.",
        coming_soon: "Próximamente",
        request_connection: "Solicite una conexión",
        request_connection_description: "Si necesita una conexión que aún no está disponible, nuestro equipo puede integrarla para usted.",
        request_message_prefix: "Hola, me gustaría solicitar una nueva integración de",
        channels: {
            all: "Todas las conexiones",
            whatsapp: "WhatsApp",
            sms: "SMS",
            rcs: "RCS",
            email: "Correo electrónico",
            whatsapp_cloud: "WhatsApp Oficial",
        },
        table: {
            connector: "Conector",
            name: "Nombre",
            monthly_value: "Valor mensual",
            cost_per_message: "Costo por envío",
            webhook: "Webhook",
            actions: "Acciones",
            status: "Estado",
            phone_number: "Número de teléfono",
        },
        categories: {
            whatsapp_description: "Integre con su plataforma de WhatsApp favorita o use la infraestructura de Kevi para no tener que contratar nada extra.",
            sms_description: "Integre con su plataforma de SMS favorita o use la infraestructura de Kevi para no tener que contratar nada extra.",
            rcs_description: "Envíe RCS con texto, imagen, card, carrusel o archivo por Comtele.",
            email_description: "Integre con su plataforma de correo electrónico favorita o use la infraestructura de Kevi para no tener que contratar nada extra.",
            whatsapp_cloud_description: "Integre con su plataforma de atención por WhatsApp Oficial.",
        },
        common: {
            set_default: "Establecer como predeterminado",
            copied_url: "Copiar URL",
            not_supported: "No compatible",
            active: "Activo",
            unavailable: "No disponible",
            not_configured: "No configurado",
            error: "Error",
            unknown: "Desconocido",
            loading: "Cargando...",
            connected: "Conectado",
            disconnected: "Desconectado",
            corrupted_instance: "Instancia dañada.",
            corrupted_instance_tooltip: "La instancia de WhatsApp está dañada y debe ser reemplazada o reconfigurada.",
            webhook_pending_tooltip: "El webhook aún no está configurado. Configúrelo para saber si los mensajes fueron leídos y recibidos.",
            webhook_error_tooltip: "Hubo un error al configurar el webhook. Revise la configuración.",
            webhook_unknown_tooltip: "No se pudo determinar el estado del webhook a través de la integración. Revíselo en su proveedor.",
            webhook_unavailable_tooltip: "Esta integración no admite webhooks.",
            sender_no_webhooks: "Este remitente no admite webhooks",
            click_view_webhooks: "Haga clic para ver los eventos de webhook",
            last_event_received: "Último evento recibido en {$0}",
            credits_suffix: "créditos",
            copied_success: "¡URL copiada con éxito!",
            copy_error: "Error al copiar la URL",
            not_available: "N/A",
        },
        sender_form: {
            details_tab: "Detalles",
            settings_tab: "Configuración",
            adding_connection: "Agregando conexión",
            connection_cost: "Costo de la conexión",
            monthly_subscription: "Suscripción mensual",
            connection_valid_per_phone: "Conexión válida por número de teléfono",
            credit_cost: "Costo de créditos",
            per_message_sent: "Por mensaje enviado",
            what_you_need_to_know: "Lo que necesita saber",
            edit: "Editar",
            close: "Cerrar",
            install_connection: "Instalar conexión",
            edit_settings: "Editar configuraciones",
            configure_how: "Cómo configurar",
            edit_instructions: "Editar instrucciones",
            edit_sender_description: "Editar descripción del remitente",
            edit_configuration_instructions: "Editar instrucciones de configuración",
            format_help: "Use la barra de formato para estilizar el texto.",
            description_placeholder: "Ingrese la descripción del remitente...",
            instructions_placeholder: "Ingrese las instrucciones de configuración...",
            cancel: "Cancelar",
            save: "Guardar",
            default_body: "<p>La información sobre esta conexión se mostrará aquí.</p>",
            default_instructions: "<p>Si necesita ayuda, contacte al soporte de Kevi por WhatsApp.</p>",
        },
        steps: {
            configure: "Configurar",
            scan: "Escanear",
            test: "Probar",
            finish: "Finalizar",
            title: "Título",
            cancel: "Cancelar",
            next: "Siguiente",
            saving: "Guardando...",
            back: "Volver",
            send_test: "Enviar prueba",
            sending_test: "Enviando prueba...",
            enter_email: "Ingrese un correo electrónico",
            example_email: "ejemplo@email.com",
            enter_mobile_number: "Ingrese un número de celular",
            enter_mobile_short: "Ingrese un celular",
            select_template: "Seleccione la plantilla",
            no_template_available: "No hay plantillas disponibles.",
            header: "Encabezado",
            body: "Cuerpo",
            button: "Botón",
            image_url: "URL de la imagen",
            header_media_url_video: "URL del video",
            header_media_url_document: "URL del documento",
            header_media_url_gif: "URL del GIF",
            document_filename: "Nombre del archivo (opcional)",
            document_filename_placeholder: "ej.: factura.pdf",
            location_header: "Ubicación (encabezado)",
            location_latitude: "Latitud",
            location_longitude: "Longitud",
            location_name: "Nombre del lugar",
            location_address: "Dirección",
            approved: "Aprobado",
            rejected: "Rechazado",
            pending: "Pendiente",
            test_completed_success: "Prueba completada con éxito",
            did_not_receive_test: "no recibí la prueba.",
            done: "Finalizar",
            channel_ready_default: "Su conexión está activa y lista para usar.",
            channel_ready_whatsapp: "Su conexión con WhatsApp está activa y lista para usar.",
            channel_ready_sms: "Su conexión SMS está activa y lista para usar.",
            channel_ready_rcs: "Su conexión RCS está activa y lista para usar.",
            channel_ready_email: "Su conexión de correo electrónico está activa y lista para usar.",
            channel_ready_whatsapp_cloud: "Su conexión de WhatsApp Cloud está activa y lista para usar.",
            connection_check_error: "Error al verificar la conexión.",
            verify_settings_or_support: "Revise la configuración o contacte al soporte.",
            scan_qr_instruction: "Abra WhatsApp y escanee el código QR",
            qr_code_error: "Error al generar el código QR.",
            whatsapp_connected: "WhatsApp conectado",
            generate_qr_again: "Generar código QR nuevamente",
            try_again: "Intentar nuevamente",
            expand_qr: "Expandir código QR",
            expanded_qr_title: "Escanear código QR",
            keep_phone_close: "Apunta la cámara de tu teléfono a la pantalla para conectar.",
            close: "Cerrar",
        },
        webhooks: {
            title: "Webhooks",
            back: "Volver",
            status_24h_summary: "Estado calculado a partir de los eventos recibidos en las últimas 24 h.",
            last_event: "Último evento: {$0}",
            description_line_1: "<strong>Webhooks</strong> son notificaciones enviadas por su proveedor (Mailgun, SMS, WhatsApp Cloud, etc.) a Kevi cuando ocurre un evento (entrega, lectura, fallo, respuesta).",
            description_line_2: "Son importantes para que Kevi pueda actualizar estados, métricas y automatizaciones de forma confiable.",
            managed_by_kevi: "Este remitente es administrado por Kevi, por lo que la URL del webhook se configura automáticamente.",
            webhook_url: "URL del webhook",
            copy: "Copiar",
            received_events: "Eventos recibidos",
            no_events: "Todavía no se ha recibido ningún evento de webhook para este remitente.",
            received_at: "Recibido en",
            event: "Evento",
            contact: "Contacto",
            client: "Cliente",
            provider_id: "Provider ID",
            status: "Estado",
            error: "Error",
            data: "Datos",
            processed: "Procesado",
            failed: "Falló",
            view_data: "Ver datos",
            details_title: "Datos del webhook",
            summary: "Resumen",
            received: "Recibido",
            provider_event: "Evento del proveedor",
            payload_json: "Payload (JSON)",
            headers_json: "Headers (JSON)",
            close: "Cerrar",
        },
        notifications: {
            load_error: "Error al cargar conexiones: {$0}",
            execute_command_error: "Error al ejecutar el comando: {$0}",
            set_default_success: "Conexión establecida como predeterminada con éxito",
            set_default_error: "Error al establecer la conexión predeterminada: {$0}",
            sender_id_not_found: "Error: no se encontró el ID del remitente. Guarde primero la configuración.",
            test_sent_success: "Prueba enviada con éxito",
            config_saved_success: "Configuración guardada con éxito",
            description_saved_success: "Descripción guardada con éxito",
            description_save_error: "Error al guardar la descripción: {$0}",
            instructions_saved_success: "Instrucciones guardadas con éxito",
            instructions_save_error: "Error al guardar las instrucciones: {$0}",
            unknown_error: "Error desconocido",
            command_executed_success: "Comando ejecutado con éxito",
            test_send_error: "Error al enviar la prueba: {$0}",
            price_updated_success: "Valor mensual actualizado con éxito",
            price_update_error: "Error al actualizar el valor mensual",
            credits_cost_updated_success: "Costo por envío actualizado con éxito",
            credits_cost_update_error: "Error al actualizar el costo por envío",
            sender_default_has_others: "Disparador predeterminado de {$0}. Defina otro predeterminado antes de eliminar.",
            sender_in_use_automations: "En uso en la(s) automatización(es): {$1}. Modifique o desactive antes de eliminar.",
            sender_in_use_branches: "Vinculado a la(s) sucursal(es): {$0}. Desvincule antes de eliminar.",
            sender_in_use_users: "Vinculado al/a los vendedor(es): {$0}. Desvincule antes de eliminar.",
            sender_not_found: "Disparador no encontrado o inactivo.",
        },
    },
};
